import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { AddWeightModalLayout } from '../ModalLayout'

class AddWeight extends Component {
    constructor() {
        super()
        this.state = {
            isAddWeightModalOpened: false,
        }
    }
    opeAddWeightModal = () => {
        this.setState({ isAddWeightModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isAddWeightModalOpened: status })
    }

    render() {
        let modalComponent = null

        if (this.state.isAddWeightModalOpened) {
            modalComponent =
                <HBBModal>
                    <AddWeightModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
            {modalComponent}

                <button
                    className="btn btn-primary button-custom button-custom-edit"
                     onClick={(e) => {
                        e.preventDefault()
                        this.opeAddWeightModal()
                    }}>
                    Verify
                </button>
                
            </div>
        )
    }
}

export default AddWeight


// WEBPACK FOOTER //
// ./src/modules/Order Verification/Components/ActionButtons/AddWeight.js